import { render } from "./NTable.vue?vue&type=template&id=7d97f838&ts=true"
import script from "./NTable.vue?vue&type=script&lang=ts"
export * from "./NTable.vue?vue&type=script&lang=ts"

import "./NTable.vue?vue&type=style&index=0&id=7d97f838&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__